<template>
  <div>
   <div class="examples">
      <div class="text-h6 title">Beispiele</div>
      <div class="text-body-1 image-examples">
        <v-img
          max-width="200"
          src="../../../../public/img/digitalisierung/RetuscheOriginal.jpg"
        ></v-img>
        <v-spacer class="spacer">
          <v-icon x-large>mdi-arrow-right-thin</v-icon>
        </v-spacer>
        <v-img
          max-width="200"
          src="../../../../public/img/digitalisierung/RetuscheBearbeitet.jpg"
        ></v-img>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.exp-panels {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.title {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.image-examples {
  display: flex;
  flex-direction: row;
}

.spacer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.request {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.has-margin-top {
  margin-top: 1rem;
}
</style>